import React, { useEffect, useState } from "react";
import { enqueueSnackbar } from "notistack";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { getAPICall, putAPICall } from "lib/callApi";
import { GET_HUB_SETTINGS } from "lib/constants";
import Loader from "utils/Loader";
import ExpandedIntegrationForm from "components/ExpandedIntegration/ExpandedIntegrationForm";
import MDSnackbar from "components/MDSnackbar";

const WinWire = () => {
  const [pageLoading, setPageLoading] = useState(true);
  const [integration, setIntegration] = useState({});
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);

  const fetchWinWireSettings = async () => {
    setPageLoading(true);
    try {
      const fetchedSettings = await getAPICall(`${GET_HUB_SETTINGS}/WinWire`, true);
      if (fetchedSettings?.data?.success) {
        setIntegration(fetchedSettings?.data?.integration || {});
      } else {
        setIntegration({});
        if (fetchedSettings.response.status !== 403) {
          enqueueSnackbar(
            JSON.stringify({
              icon: "error",
              title: "Error",
              text: fetchedSettings.response.data.message || "Something Went Wrong",
            }),
            {
              variant: "custom",
            }
          );
        }
      }
    } catch (err) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Error",
          text: err.message || "Something Went Wrong",
        }),
        {
          variant: "custom",
        }
      );
    } finally {
      setPageLoading(false);
    }
  };

  const onSubmit = async (data) => {
    try {
      setSaving(true);
      const result = await putAPICall(`${GET_HUB_SETTINGS}/WinWire`, true, data);
      if (result.status === 200) {
        setShowSnackbar(true);
        setHasChanges(false);
        fetchWinWireSettings();
      } else {
        enqueueSnackbar(
          JSON.stringify({
            icon: "error",
            title: "Error",
            text:
              result?.response?.data?.errorMessage ||
              "Something went wrong! Development has been notified.",
          }),
          {
            variant: "custom",
          }
        );
      }
    } catch (err) {
      console.log("err", err);
    } finally {
      setSaving(false);
    }
  };

  const closeSnackbar = () => setShowSnackbar(false);

  useEffect(() => {
    fetchWinWireSettings();
  }, []);

  return (
    <Grid item xs={12}>
      <Loader loading={pageLoading} />
      <Card>
        <MDBox p={3}>
          <MDTypography variant="h4" pb={4}>
            Win-Wire
          </MDTypography>

          <ExpandedIntegrationForm
            integrationName="WinWire"
            integration={integration}
            saving={saving}
            hasChanges={hasChanges}
            onSubmit={onSubmit}
            setHasChanges={setHasChanges}
          />
        </MDBox>
      </Card>
      <MDSnackbar
        color="success"
        icon="checkCircleIcon"
        title="Success"
        content="Win Wire settings saved successfully"
        open={showSnackbar}
        onClose={closeSnackbar}
        close={closeSnackbar}
        bgWhite
      />
    </Grid>
  );
};

export default WinWire;
